const sysInfo = {
  // 本地调试
  ifDebug: false,
  // apiRemote: 'http://172.22.16.208:18080/web',

  // 发布正式环境地址
  // ifDebug: false,
  apiRemote: 'https://geam.hangyang.com/eampro',
  // 跳转登录的地址——正式环境
  loginURl: 'https://oa.hangyang.com/sso/oauth2.0/authorize?client_id=9ecd74cf-bd60-454c-b081-db27ee30f52b&redirect_uri=https://geam.hangyang.com/user/login&response_type=code',

  // 发布测试环境地址loginURl
  // ifDebug: true,
  // apiRemote: 'https://172.18.6.177/eampro',
  // 测试登录的地址——测试环境
  // loginURl: 'http://172.18.6.189:8080/wui/index.html#/?appid=288386af-0d92-4f26-bad3-3e74be54b7f1&service=http://172.22.3.127:8000/user/login&_key=1yna2d',

  apiFpsRemote: 'http://192.168.2.246:10095/fps', // 测试地址
  previewUrl: 'http://192.168.2.246:10095', // 测试地址

  apiLocal: 'http://172.22.3.127:8000/data', // ip端口改成自己本地的  MODAL_ADD: 'MODAL_ADD',
  MODAL_MODIFY: 'MODAL_MODIFY',
  MODAL_VIEW: 'MODAL_VIEW',
  MODAL_ADD: 'MODAL_ADD',

  previewAccount: '7yQgiiNKRo', // 测试
  previewToken: 'JER7X2EWRGRIMK6KHFTGJBQI5STNIACEWZ5GMLKI42HDDJEEAFSA' // 测试

  // 正式环境替换
  // apiRemote: 'http://115.29.178.146:9012', // 远程demo正式地址
  // apiFpsRemote: 'http://115.29.178.146:9014/fps',
  // previewUrl: 'http://115.29.178.146:9014',
  // previewAccount: 'C2x5Gupa',
  // previewToken: 'JER7X2EWRGRIMK6KHFTGJBQI5STNIACEWZ5GMLKI42HDDJEEAFSA'

}

export {
  sysInfo
}
